import $ from 'jquery';

export default function () {
    $(".preloader-wrapper").fadeOut(500);
}